import React from 'react';
import styles from './UttamKalakarHeader.module.css'; // Import scoped styles

function UttamKalakarHeader() {
    return (
        <div className={styles['main-content']}>
            <img
                src="/assets/NRDRUHSHomeBanner.jpg"
                alt="Background"
                className={styles['header-image']}
            />
        </div>
    );
}

export default UttamKalakarHeader;
